// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum SquareIconsEnum {
  'arrow-down-18' = 'arrow-down-18',
  'bell-24' = 'bell-24',
  'checkmark-18' = 'checkmark-18',
  'close-16' = 'close-16',
  'close-20' = 'close-20',
  'discover-18' = 'discover-18',
  'dots-18' = 'dots-18',
  'download-20' = 'download-20',
  'edit-24' = 'edit-24',
  'eye-18' = 'eye-18',
  'eye-disable-18' = 'eye-disable-18',
  'hamburger-26-20' = 'hamburger-26-20',
  'help-24' = 'help-24',
  'plus-18' = 'plus-18',
  'settings-24' = 'settings-24'
}

enum SquareIconsMapperEnum {
  'arrowDown' = 'arrow-down-18',
  'checkmark' = 'checkmark-18',
  'close' = 'close-20',
  'closeSmall' = 'close-16',
  'discover' = 'discover-18',
  'dots' = 'dots-18',
  'dotsShifted' = 'dots-18',
  'edit' = 'edit-24',
  'hamburger' = 'hamburger-26-20',
  'help' = 'help-24',
  'hide' = 'eye-disable-18',
  'notification' = 'bell-24',
  'plus' = 'plus-18',
  'settings' = 'settings-24',
  'show' = 'eye-18',
  'download' = 'download-20'
}

export enum SquareButtonIconsEnum {
  'arrowDown' = 'arrowDown',
  'checkmark' = 'checkmark',
  'close' = 'close',
  'closeSmall' = 'closeSmall',
  'discover' = 'discover',
  'dots' = 'dots',
  'dotsShifted' = 'dotsShifted',
  'edit' = 'edit',
  'hamburger' = 'hamburger',
  'help' = 'help',
  'hide' = 'hide',
  'notification' = 'notification',
  'plus' = 'plus',
  'settings' = 'settings',
  'show' = 'show',
  'download' = 'download'
}

export const mapSquareButtonIconsToSvgFileName = (rowState: SquareButtonIconsEnum): SquareIconsEnum => {
  const mapped = SquareIconsMapperEnum[rowState];
  return SquareIconsEnum[mapped];
};
